import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import classnames from "classnames";
import styles from "@/styles/Steps.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var IconStepsActive = function IconStepsActive(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M6.109,19.341,0,20.571l1.233-6.107ZM2.446,13.251l4.875,4.876L20.572,4.876,15.7,0,2.446,13.251Z",
      transform: "translate(0.638 0.707)",
      fill: "none",
      stroke: "#e6e6e6",
      strokeWidth: "1"
    })
  }));
};

IconStepsActive.defaultProps = {
  viewBox: "0 0 21.918 21.917"
};

var IconStepsPrev = function IconStepsPrev(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M20,4.571,6.394,19,0,11.455l.634-.54,5.792,6.836L19.393,4Z",
      transform: "translate(0 -4)",
      fill: "#E6E6E6"
    })
  }));
};

IconStepsPrev.defaultProps = {
  width: "20",
  height: "15",
  viewBox: "0 0 20 15"
};
export default function Steps(_ref) {
  var step = _ref.step,
      steps = _ref.steps;
  var lastStep = steps.length;
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.steps, _defineProperty({}, styles["steps--last"], step === lastStep)),
    children: steps.map(function (value, i) {
      var _classnames2;

      return /*#__PURE__*/_jsxs("div", {
        className: classnames(styles.step, (_classnames2 = {}, _defineProperty(_classnames2, styles.prev, step > i + 1), _defineProperty(_classnames2, styles.active, step == i + 1), _defineProperty(_classnames2, styles.next, step == i), _defineProperty(_classnames2, styles.first, i == 0), _defineProperty(_classnames2, styles.between, i > 0 && i + 1 < lastStep), _defineProperty(_classnames2, styles.last, lastStep == i + 1), _classnames2)),
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.label,
          children: "STEP".concat(i + 1)
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.icon,
          children: [/*#__PURE__*/_jsx("span", {
            className: styles.activeIcon,
            children: /*#__PURE__*/_jsx(IconStepsActive, {})
          }), /*#__PURE__*/_jsx("span", {
            className: styles.prevIcon,
            children: /*#__PURE__*/_jsx(IconStepsPrev, {})
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: styles.caption,
          children: value
        })]
      }, "step-".concat(i));
    })
  });
}